import React from 'react';
import { CaseRecordReviewStatusData, StatusColor, StatusLabel } from './useCaseRecordReviewStatus';
import { Button, Typography } from '@mui/material';
import { Buttons, FormGrid, SimpleDialog } from '../../toolympus/components/primitives';
import { CaseRecord } from './useCaseRecordsList';
import { checkRole, useUser } from '../../toolympus/userContext/UserContext';
import { ArrowRightAlt, Check, WarningOutlined } from '@mui/icons-material';
import { FormControlsForFields, useFormats } from '../../toolympus/components/schemed';
import { utc } from '../../toolympus/components/timezone';
import { FieldType, Schema } from '../../toolympus/hooks/useSchema';

interface Props {
  data: CaseRecordReviewStatusData;
}

const StatusUpdateSchema: Schema = {
  comment: { label: "Комментарий", type: FieldType.textlong },
}

export const CaseRecordReviewStatusButton = (props: Props) => {
  const { data } = props;

  const { user } = useUser();

  const formats = useFormats();

  return (
    <>
      <Button
        size="small"
        startIcon={data.status === "confirmed-done"
            ? <Check />
            : data.status === "needs-fixing"
              ? <WarningOutlined />
              : undefined
        }
        onClick={() => data.dialog.open()}
        style={{ color: data.statusInfo.color }}>
        {data.statusInfo.label}
      </Button>

      <SimpleDialog
        dialogTitle={`Статус: ${data.statusInfo.label}`}
        isOpen={data.dialog.isOpen}
        save={() => data.update(data.stage.newStatus)}
        close={() => data.dialog.close()}
        submitOnModEnter
        noSave
        noFullscreen>

        {!!data.statusDatetime &&
          <Typography>
            Статус обновлен: <span style={{ fontWeight: 500 }}>{formats.formatDatetime(utc.toLocal(data.statusDatetime))}</span>
          </Typography>}
        
        {!data.status &&
          <Typography>
            Если заполнение информации о решении завершено, вы можете отметить решение как завершенное - в таком случае оно пропадет из дэшбордов с ошибками.

            Решение с незаполненными полями, отмеченное как звершенное, попадет в дэшборды для ревью. Если потребуется, его вернут на доработку.
          </Typography>}

          {data.status === "considered-done" &&
            <Typography>
              Решение отмечено как завершенное. Если требуется, его можно вернуть на доработку.
            </Typography>}

          {data.status === "confirmed-done" &&
            <Typography>
              Решение отмечено как завершенное и прошло ревью. Если требуется, его можно вернуть на доработку.
            </Typography>}

          {data.status === "needs-fixing" &&
            <Typography>
              По решению запрошена доработка. После внесения правок отметьте его как завершенное.
            </Typography>}

          <FormGrid columns="1fr">
            {data.stageX === "initial" && ([
              ["considered-done", "заполнение завершено", !data.status || data.status === "needs-fixing"],
              ["confirmed-done", "подтвердить завершение", checkRole(user, "manager") && data.status !== "confirmed-done"],
              ["needs-fixing", "требуются правки", data.status !== "needs-fixing"],
            ] as [NonNullable<CaseRecord["review_status"]>,string,boolean][])
            .filter(([action,label,available]) => !!available)
            .map(([action,label]) => (
              <Button size="small" key={action} onClick={() => data.update(action)} style={{ color: StatusColor[action] }}>
                {label}
              </Button>
            ))}

            {data.stageX === "comment" && <>
              <Buttons>
                <ArrowRightAlt color="action" /> <Typography style={{ color: (StatusColor as any)[data.stage.newStatus || ""] }}>{(StatusLabel as any)[data.stage.newStatus || ""]}</Typography>
              </Buttons>
              <FormControlsForFields
                data={{ comment: data.comment.value }}
                onChange={(o,c) => data.comment.update(c.comment)}
                schema={StatusUpdateSchema}
                fields={[
                  ["comment", { label: data.comment.isRequired ? undefined : "Комментарий (необязательно)", controlProps: { autoFocus: true }}],
                ]}
                errors={data.errors}
                />
              
              <Button size="small" onClick={() => data.update(data.stage.newStatus as any)} color="primary">
                подтвердить (ctrl+enter)
              </Button>
            </>}
          </FormGrid>
      </SimpleDialog>
    </>
  );
}
